import { NextPageWithLayout } from 'next';
import { Diagnostic } from '@modules/diagnostics/model';
import { getPageInitialProps, HttpResult } from '@core/http';
import { renderHttpResult } from '@shared/utils/render';
import Ticket from '@modules/ticket/Ticket';
import { pipe } from 'fp-ts/function';
import { sequenceS } from 'fp-ts/Apply';
import * as TE from 'fp-ts/TaskEither';
import { getStringQuery, queryToHttpTask } from '@shared/utils/queries';
import * as DiagnosticsService from '@modules/diagnostics/service';

interface FailurePageProps {
  diagnostic: Diagnostic;
  answerId: string;
}

const FailurePage: NextPageWithLayout<HttpResult<FailurePageProps>> = res =>
  renderHttpResult(res, ({ diagnostic, answerId }) => <Ticket diagnostic={diagnostic} answerId={answerId} />);

FailurePage.getLayoutProps = () => ({ headerLight: true });

FailurePage.getInitialProps = getPageInitialProps(ctx =>
  pipe(
    sequenceS(TE.ApplyPar)({
      diagnosticNumber: queryToHttpTask(getStringQuery(ctx.query, 'diagnostic_number')),
      answerId: queryToHttpTask(getStringQuery(ctx.query, 'answer_id')),
    }),
    TE.chain(({ diagnosticNumber, answerId }) =>
      sequenceS(TE.ApplyPar)({
        diagnostic: DiagnosticsService.getDiagnosticsDetail(diagnosticNumber),
        answerId: TE.right(answerId),
      }),
    ),
  ),
);

export default FailurePage;
